import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboardbox',
    templateUrl: './dashboardbox.component.html',
    styleUrls: ['./dashboardbox.component.scss'],
    standalone: false
})
export class DashboardboxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
